import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

/** calculate calender days */
function CalendarDay(props) {
  const { day, isToday, events, onClick } = props;
  
    if(!day){
        return null
    }
    const dayClasses = classnames({
      flexColumn: true,
      day: true,
      inactive: day.siblingMonth,
      today: isToday
    });

    return (
      <div onClick={onClick.bind(null, this, day)} className={dayClasses}>
        <div className={"inner-grid"}>
          <div className={"date"}>{day.day}</div>
          {events}
        </div>
      </div>
    );
  }

/** above function property */
CalendarDay.propTypes = {
  day: PropTypes.object.isRequired,
  isToday: PropTypes.bool,
  events: PropTypes.array,
  onClick: PropTypes.func
};

/** above function property */
CalendarDay.defaultProps = {
  onClick: () => {}
};

export default CalendarDay;